import { useState } from "react";
import { X } from "lucide-react";

const inputCls = "w-full border border-gray-300 rounded-sm px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#002FA7] focus:border-transparent";

export function TagEditor({ tags, onChange }) {
  const [tagInput, setTagInput] = useState("");

  const addTag = (e) => {
    e.preventDefault();
    const t = tagInput.trim();
    if (t && !tags.includes(t)) onChange([...tags, t]);
    setTagInput("");
  };

  return (
    <div>
      <label className="block text-sm font-semibold text-gray-700 mb-1">Tags</label>
      <div className="flex gap-2">
        <input data-testid="client-tag-input" value={tagInput} onChange={(e) => setTagInput(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") addTag(e); }}
          placeholder="Type and press Enter" className={inputCls} />
        <button type="button" onClick={addTag} className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-3 rounded-sm text-sm font-semibold">Add</button>
      </div>
      {tags.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-2">
          {tags.map((t) => (
            <span key={t} className="inline-flex items-center gap-1 bg-[#002FA7]/10 text-[#002FA7] text-xs font-semibold px-2 py-1 rounded-sm">
              {t}
              <button type="button" onClick={() => onChange(tags.filter((x) => x !== t))}><X className="w-3 h-3" /></button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
